<template>
  <div class="publicMain">
    <!-- 查询区域组件getIsShow('lkdwTil') -->
    <el-row class="leftClass">
      <el-col :span="4">
        <FetchSuggestionsBox
          :id="'xm'"
          class="inputClass"
          :uniqueNum="uniqueNum"
          @conditionVal="emitCondition"
          :inputData="getArgumentDetail('nameTil')"
        ></FetchSuggestionsBox>
      </el-col>
      <el-col :span="4">
        <FetchSuggestionsBox
          :id="'dlm'"
          class="inputClass"
          :uniqueNum="uniqueNum"
          @conditionVal="emitCondition"
          :inputData="getArgumentDetail('loginNameTil')"
        ></FetchSuggestionsBox>
      </el-col>
      <el-col :span="4">
        <FetchSuggestionsBox
          :id="'cznr'"
          class="inputClass"
          :uniqueNum="uniqueNum"
          @conditionVal="emitCondition"
          :inputData="getArgumentDetail('contentTil')"
        ></FetchSuggestionsBox>
      </el-col>
      <el-col :span="5">
        <DatePickerBox
          :id="'kssj'"
          :type="'datetime'"
          :uniqueNum="uniqueNum"
          @conditionVal="emitCondition"
          :inputData="getArgumentDetail('startTimeTil')"
        ></DatePickerBox>
      </el-col>
      <el-col :span="5">
        <DatePickerBox
          :id="'jssj'"
          :type="'datetime'"
          :uniqueNum="uniqueNum"
          @conditionVal="emitCondition"
          :inputData="getArgumentDetail('endTimeTil')"
        ></DatePickerBox>
      </el-col>
    </el-row>
    <el-row class="btnGroup">
      <!-- <ButtonGroupBox></ButtonGroupBox> -->
      <!-- 按钮组件 -->
      <el-col :span="24" class="dy-flex">
        <ButtonBox
          type="primary"
          :id="'btn-cx'"
          :buttonData="getArgumentDetail('cxTil')"
          class="mx-5"
          @click.native="getCzrzList('X116104-1-1', 'query')"
          :queryCondition="queryForm['X116104-1-1']"
        ></ButtonBox>
        <ButtonBox
          type="primary"
          :id="'btn-cz'"
          :buttonData="getArgumentDetail('czTil')"
          class="mx-5"
          @click.native="reset"
          :uniqueNum="'X116104-1-1'"
        ></ButtonBox>
        <ButtonBox
          type="primary"
          :id="'btn-sccx'"
          :buttonData="getArgumentDetail('sccxTil')"
          class="mx-5"
          @click.native="getCzrzList('X116104-1-1', 'query')"
          :uniqueNum="'X116104-1-1'"
        ></ButtonBox>
        <ButtonBox
          type="primary"
          :id="'btn-pfcx'"
          :buttonData="getArgumentDetail('pfcxTil')"
          class="mx-5"
          @click.native="getCzrzList('X116104-1-1', 'query')"
          :uniqueNum="'X116104-1-1'"
        ></ButtonBox>
        <el-popover width="100" placement="bottom" trigger="click" class="mx-5">
          <!-- 表格显示列组件 -->
          <TreeBox :uniqueNum="uniqueNum"></TreeBox>
          <el-button
            type="primary"
            size="mini"
            slot="reference"
            style="margin-left: 10px"
            >{{ $t("common.popoverTitle") }}
          </el-button>
        </el-popover>
        <ExportAndPrintBox
          :size="'mini'"
          :menuList="menuList"
          :tableColumns="tableData"
          :selectedKeyArr="selectedKeyArr"
          :exportTitle="exportTitle"
          :conditionMap="map"
          :queryForm="lastQueryCondition"
          :argumentDetail="getArgumentDetail('funTil')"
          :uniqueNum="'X116104-1-1'"
        ></ExportAndPrintBox>
      </el-col>
    </el-row>
    <el-row>
      <!-- 动态表格组件 -->
      <TableCommon
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :tableColumns="tableColumns"
        :tableData="tableData"
        :currentPage="currentPage"
        :limit="limit"
        :uniqueNum="uniqueNum"
        :reserveSelection="reserveSelection"
        :cellStyle="$store.state.cellStyle"
        :headerCellStyle="$store.state.headerCellStyle"
      ></TableCommon>
    </el-row>
    <el-row>
      <!-- 分页组件 -->
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        :small="true"
        :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :uniqueNum="uniqueNum"
      />
    </el-row>
  </div>
</template>

<script>
var timer;

export default {
  name: "czrz",
  computed: {
    /** 获取指定参数值 */
    getTitle(key) {
      let context = this;
      return (key) => {
        let detail = this.getArgumentDetail(key);
        if (context.$comUtils.isEmpty(detail)) {
          return "";
        }
        return detail.componentTiltle[this.$i18n.locale];
      };
    },
    map() {
      if (Object.keys(this.argumentDetail).length === 0) {
        return {};
      }
      return {
        xm: this.getArgumentDetail("nameTil"),
        dlm: this.getArgumentDetail("loginNameTil"),
        cznr: this.getArgumentDetail("contentTil"),
        kssj: this.getArgumentDetail("startTimeTil"),
        jssj: this.getArgumentDetail("endTimeTil"),
      };
    },
    exportTitle() {
      return this.$t("czrz.operationLogTitle");
    },
  },
  data() {
    return {
      lastQueryCondition: {},
      tabLoading: false,
      conditionData: [], // 查询条件数据
      buttonData: [], // 按钮数据
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      tableData: [], // 表格数据
      tableColumns: [], // 动态表配置信息
      queryForm: {}, // 查询条件
      layoutForm: {}, // 布局信息form表单
      layoutFlg: this.$store.state.pageLayout, // 查询条件布局方式  1: 平铺  2: 略缩图
      uniqueNum: "X116104-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      menuList: [
        { method: "excel", url: "/api/xtglCzrz/exportExcelOrPdf" },
        { method: "pdf", url: "/api/xtglCzrz/exportExcelOrPdf" },
        {
          method: "print",
          url: "/api/xtglCzrz/getCzrzList",
          getDataMethod: (response) => {
            return response.data.data;
          },
        },
      ],
      reserveSelection: true,
      selectedKeyArr: [], //选中的列
      // 定义变量的moduleId、groupId 和 fieldId
      argumentDetail: {},
      argumentConfig: {
        nameTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "input-xm",
        },
        loginNameTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "input-dlm",
        },
        contentTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "input-cznr",
        },
        startTimeTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "startTime",
        },
        endTimeTil: {
          moduleId: "1",
          groupId: "1",
          fieldId: "endTime",
        },
        cxTil: {
          moduleId: "1",
          groupId: "2",
          fieldId: "btn-cx",
        },
        czTil: {
          moduleId: "1",
          groupId: "2",
          fieldId: "btn-cz",
        },
        sccxTil: {
          moduleId: "1",
          groupId: "2",
          fieldId: "btn-sccx",
        },
        pfcxTil: {
          moduleId: "1",
          groupId: "2",
          fieldId: "btn-pfcx",
        },
        funTil: {
          moduleId: "1",
          groupId: "2",
          fieldId: "dropdown",
        },
      },
    };
  },
  watch: {
    "$store.state.pageLayout"(val) {
      this.layoutFlg = val;
    },
  },
  methods: {
    // 获取查询条件信息
    loadQueryConfig() {
      let queryInfo = {
        pageId: "X116104",
      };
      this.$requestUtil.getXtQueryConfigMy(queryInfo).then((res) => {
        this.argumentDetail = res;
      });
    },
    /** 获取参数详情 */
    getArgumentDetail(key) {
      return this.$requestUtil.getArgumentDetail(
        this.argumentConfig,
        this.argumentDetail,
        key
      );
    },
    emitCondition(uniqueNum, data) {
      if (
        !(
          Object.prototype.toString.call(this.queryForm[uniqueNum]) ==
          "[object Object]"
        )
      ) {
        this.queryForm[uniqueNum] = {};
      }
      if (data.id == "xm") {
        this.queryForm[uniqueNum].xm = data.val;
      } else if (data.id == "dlm") {
        this.queryForm[uniqueNum].dlm = data.val;
      }else if (data.id == "cznr") {
        this.queryForm[uniqueNum].cznr = data.val;
      } else if (data.id == "kssj") {
        this.queryForm[uniqueNum].kssj = data.val;
      } else if (data.id == "jssj") {
        this.queryForm[uniqueNum].jssj = data.val;
      } else {
        this.queryForm[uniqueNum].xm = "";
        this.queryForm[uniqueNum].dlm = "";
        this.queryForm[uniqueNum].cznr = "";
        this.queryForm[uniqueNum].kssj = "";
        this.queryForm[uniqueNum].jssj = "";
      }
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig(areaCode) {
      let _this = this;
      let tmpData = {};
      let params = {};
      params.pageId = areaCode.split("-")[0];
      params.moduleId = areaCode.split("-")[1];
      params.groupId = areaCode.split("-")[2];
      // 清空表格列配置
      _this.tableColumns = []; // 表格列
      // 异步回调
      _this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        _this.tableColumns = tmpResult;
      });
    },
    /** 取得列表信息 */
    getCzrzList(uniqueNum, flg) {
      let _this = this;
      let tmpData = {};
      _this.lastQueryCondition = {};
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (Object.keys(_this.queryForm).length == 0) {
          _this.queryForm[uniqueNum] = {};
        }
        _this.queryForm[uniqueNum].pageId = uniqueNum.split("-")[0];
        _this.queryForm[uniqueNum].moduleId = uniqueNum.split("-")[1];
        _this.queryForm[uniqueNum].groupId = uniqueNum.split("-")[2];
        // _this.queryForm[uniqueNum].currentPage = _this.currentPage;
        // _this.queryForm[uniqueNum].limit = _this.limit;
        if (flg == "query") {
          _this.queryForm[uniqueNum].currentPage = 1;
          _this.queryForm.limit = _this.$store.state.dataDisplayNum;
          _this.currentPage = 1;
        } else {
          _this.queryForm[uniqueNum].currentPage = _this.currentPage;
          _this.queryForm[uniqueNum].limit = _this.limit;
        }
        for (let ObjName in _this.queryForm) {
          if (ObjName == uniqueNum) {
            tmpData = _this.queryForm[uniqueNum];
            break;
          }
        }
        if (tmpData.kssj && tmpData.jssj) {
          if (tmpData.kssj > tmpData.jssj) {
            _this.$message.error("开始时间不能大于结束时间");
            return;
          }
        }
        _this.lastQueryCondition = tmpData;
        _this.tableData = [];
        _this.tabLoading = true; // 关闭请求时的loading层
        _this.$ajax
          .post("/api/xtglCzrz/getCzrzList", tmpData)
          .then((res) => {
            _this.tabLoading = false; // 关闭请求时的loading层
            if (res.data.code == "200") {
              if (res.data.data.length > 0) {
                _this.total = res.data.data[0].tableCount;
              } else {
                _this.total = 0;
              }
              _this.tableData = res.data.data;
            }
          })
          .catch((error) => {
            _this.tabLoading = false; // 关闭请求时的loading层
          });
      }, 100);
    },
    /** 重置按钮 */
    reset() {
      this.currentPage = 1;
      this.getCzrzList(this.uniqueNum);
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      // this.getCzrzList(this.uniqueNum);
      if (
        !(
          Object.prototype.toString.call(this.queryForm[uniqueNum]) ==
          "[object Object]"
        )
      ) {
        this.queryForm[uniqueNum] = {};
      }
      this.queryForm[uniqueNum].currentPage = val;
      this.getCzrzList(uniqueNum);
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      if (
        !(
          Object.prototype.toString.call(this.queryForm[uniqueNum]) ==
          "[object Object]"
        )
      ) {
        this.queryForm[uniqueNum] = {};
      }
      this.queryForm[uniqueNum].limit = val;
      this.queryForm[uniqueNum].currentPage = 1;
      this.getCzrzList(uniqueNum);
    },
  },
  created() {},
  mounted() {
    let _this = this;
    _this.loadQueryConfig();
    _this.getPageTableConfig(_this.uniqueNum);
    _this.getCzrzList(_this.uniqueNum);
    // 获取表头信息
    _this.$root.$on("tableHeader" + _this.uniqueNum, (data) => {
      _this.selectedKeyArr = data;
    });
    _this.$root.$on("resetQueryForm" + _this.uniqueNum, (data) => {
      // 重置查询条件
      _this.queryForm.xm = "";
      _this.queryForm.dlm = "";
      _this.queryForm.kssj = "";
      _this.queryForm.jssj = "";
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .inputClass .el-input {
  width: 90%;
}
</style>
